import React from "react"
import HeadTitle from "../../common/HeadTitle/HeadTitle"
import AllItem from "./Allitem"

const Testimonial = () => {
  return (
    <>
      <HeadTitle />
      <AllItem />
    </>
  )
}

export default Testimonial